// 金额：后端以“分”为单位的整数返回
export function formatPrice(cents) {
  if (cents === null || cents === undefined || cents === "") {
    return "--";
  }
  return (Number(cents) / 100).toFixed(2);
}

export function formatTime(ts) {
  if (!ts) return "-";
  const d = new Date(Number(ts));
  const p = (n) => (n < 10 ? "0" + n : "" + n);
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(
    d.getHours()
  )}:${p(d.getMinutes())}:${p(d.getSeconds())}`;
}

export function isPhone(v) {
  return /^1[3-9]\d{9}$/.test(v);
}
